export default "__VITE_ASSET__CudPoZvg__"